<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "CardListApplicants",
  props: {
    active_item: {
      type: Object
    }
  },
  data: () => ({
    search_table: '',
    page: 1,
    pageCount: 0,
    drawer: false,
    curr_state: {},
    curr_place: [],
    headers_table_state_applicants: [
      {text: 'МЕСТО', value: 'id', sortable: false, align: 'center'},
      {text: 'ФИО', value: 'full_name', sortable: false},
      {text: 'ПРИЗНАК', value: 'privilege', sortable: false, align: 'center'},
      {text: 'СТАТУС', value: 'dean_ex_work_confirm', sortable: false, align: 'center'},
      {text: 'ДАТА ОТПРАВЛЕНИЯ', value: 'created_at', sortable: false},
      {text: 'ДЕЙСТВИЯ', value: 'actions', sortable: false, align: 'center'},
    ],
    items: [
      {text: 'Комната пустая', color: 'grey'},
      {text: 'Комната заполнена', color: 'green'},
      {text: 'Комната частично заполнена', color: 'orange'},
    ],
    open: [],
  }),
  mounted() {
  },
  computed:{
    ...mapState({
      stm_applicants: state => state.interactionStatement.stm_applicants,
      status_applicants_statements: state => state.interactionStatement.status_applicants_statements,
      result_data_statements: state => state.interactionStatement.result_data_statements,
    }),
    data_items(){
      return this.stm_applicants.stm_hostel_all
    },
  },
  watch:{},
  methods: {
    ...mapMutations({
      pushResDataStates: 'interactionStatement/pushResDataStates',
    }),
    ...mapActions({

    }),
    setStatus(current_status) {
      if (current_status === 1) {
        return {color: 'orange', icon: 'fa fa-exclamation-circle'}
      } else if (current_status === 2) {
        return {color: 'green', icon: 'fa fa-check-circle'}
      } else if (current_status === 0) {
        return {color: 'red', icon: 'fa fa-times-circle'}
      }
    },
    transitionStatementDetails(stm_hostel_id){
      this.GetDetailsStatement(stm_hostel_id)

      this.$emit('setSelectCurrentStmHostel', {
        stm_hostel_id: stm_hostel_id
      })

      this.$emit('transitionStatementDetails')
    }
  }

}
</script>

<template>
  <v-card height="570px" class="d-flex flex-column">
    <v-card-text>
      <v-row no-gutters>
        <v-spacer/>
        <div class="d-flex align-end">
          <span>Всего заявлений: </span>
          <span v-if="stm_applicants.count_statements" class="ml-1 font-weight-bold ">{{ stm_applicants.count_statements }}</span>
          <span v-else class="ml-1">
            <v-progress-circular
              indeterminate
              color="teal"
              :size="20"
              :width="2"
            ></v-progress-circular>
          </span>
        </div>
      </v-row>
    </v-card-text>

    <v-divider/>

    <v-data-table
        :headers="headers_table_state_applicants"
        :items="data_items"
        :items-per-page="12"
        :page.sync="page"
        :sort-by="['privilege','created_at']"
        :sort-desc="[false, true]"
        loading-text="Загрузка заявлений... пожалуйста подождите"
        @page-count="pageCount = $event"
        no-data-text="По предложенным критериям данные отсутствуют"
        hide-default-footer
        mobile-breakpoint="0"
    >
      <!--              <template v-slot:top>-->
      <!--                <v-app-bar-->
      <!--                    elevation="0"-->
      <!--                >-->
      <!--                  <v-app-bar-nav-icon @click.stop="drawer_left = !drawer_left">-->
      <!--                    <template v-slot:default>-->
      <!--                      <v-icon small>-->
      <!--                        fa-bars-->
      <!--                      </v-icon>-->
      <!--                    </template>-->
      <!--                  </v-app-bar-nav-icon>-->

      <!--                  <v-spacer></v-spacer>-->

      <!--                  <v-text-field-->
      <!--                      v-model="search_table"-->
      <!--                      label="Поиск"-->
      <!--                      dense-->
      <!--                      outlined-->
      <!--                      hide-details-->
      <!--                      clearable-->
      <!--                      @click:clear="search_table = ''"-->
      <!--                  >-->
      <!--                    <template v-slot:prepend>-->
      <!--                      <v-icon size="20px">-->
      <!--                        fa-search-->
      <!--                      </v-icon>-->
      <!--                    </template>-->
      <!--                  </v-text-field>-->
      <!--                </v-app-bar>-->
      <!--              </template>-->
      <template v-slot:item.actions="{ item }">
        <v-btn @click="transitionStatementDetails(item.id)" small icon>
          <v-icon size="15px">
            fa fa-eye
          </v-icon>
        </v-btn>
      </template>
      <template v-slot:item.status_commission.status_review="{ item }">
        <v-icon size="20px" :color="setStatus(item.status_commission.status_review).color">
          {{ setStatus(item.status_commission.status_review).icon }}
        </v-icon>
      </template>
      <template v-slot:item.privilege="{ item }">
        <v-icon
            v-if="item.privilege === 'Отсутствует'"
            size="20px"
        >
          fa-universal-access
        </v-icon>
        <v-icon
            v-else
            size="20px"
            color="green"
        >
          fa-universal-access
        </v-icon>
      </template>
    </v-data-table>
    <v-spacer/>
    <v-card-actions>
      <v-pagination
        class="mx-auto"
        v-model="page"
        total-visible="8"
        :length="pageCount"
        color="teal"
        circle
      ></v-pagination>
    </v-card-actions>
  </v-card>
</template>

<style scoped>

</style>